export const LoadingStep = {
  FINDING: 'finding',
  FILTERING: 'filtering',
  RANKING: 'ranking',
  SUMMARIZING: 'summarizing',
};

export const getLoadingText = (intl, step) => {
  switch (step) {
    case LoadingStep.FINDING:
      return intl.formatMessage({ id: 'loadingScreen.finding' });

    case LoadingStep.FILTERING:
      return intl.formatMessage({ id: 'loadingScreen.filtering' });

    case LoadingStep.RANKING:
      return intl.formatMessage({ id: 'loadingScreen.ranking' });

    case LoadingStep.SUMMARIZING:
      return intl.formatMessage({ id: 'loadingScreen.summarizing' });

    default:
      return '';
  }
};

export const getStepFromStreamEvent = (data) => {
  if (data.type !== 'status') return null;

  if (data.node === 'TOOLS' && data.message === 'Searching hotels...') {
    return LoadingStep.FILTERING;
  }

  if (data.node === 'TOOLS' && data.message === 'Refining results...') {
    return LoadingStep.RANKING;
  }

  if (data.node === 'RESPONSE' && data.message === 'Preparing your recommendations...') {
    return LoadingStep.SUMMARIZING;
  }

  return null;
};
